const config = {
  API_BASE_URL: "https://server.radhikaagroindustries.com", 
  // API_BASE_URL: "https://fms-server-8gas.onrender.com", 
  // API_BASE_URL: "http://localhost:5000", 
};

export default config;